module.exports = __webpack_public_path__ + "static/media/prev-cal-icon.cc33280d.svg";